"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FilterNavItem = FilterNavItem;
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _tracking = _interopRequireDefault(require("@site/pattern-library-utils/tracking"));
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _motionFunctions = require("@site/pattern-library-core/motion-functions");
var _breakpoints = require("@site/pattern-library-utils/breakpoints");
var _patternLibraryUtils = require("@site/pattern-library-utils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/** @module FilterNav */

const Container = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Container",
  class: "pl-cxvyw3"
});
const GroupList = /*#__PURE__*/(0, _react2.styled)("ul")({
  name: "GroupList",
  class: "pl-g1do9m7l"
});
const FilterButton = /*#__PURE__*/(0, _react2.styled)("button")({
  name: "FilterButton",
  class: "pl-fdm4ey5"
});
const List = /*#__PURE__*/(0, _react2.styled)("li")({
  name: "List",
  class: "pl-l1rfofda"
});

/**
 * FilterNavItem Component.
 *
 * @param {Object} props React props
 * @param {String} props.id Id for each item
 * @param {String} props._name Tracking name for each item
 * @param {String} props.filterName Button Text
 * @param {Function} props.onClick Forwarded Func
 * @param {Boolean} props.active Active State
 * @param {String} props.value Forwarded Value
 * @returns {React.ReactElement} FilterNavItem Component
 * @public
 */

function FilterNavItem({
  id,
  _name,
  filterName,
  onClick,
  active,
  value
}) {
  if (!filterName) return null;
  return /*#__PURE__*/_react.default.createElement(List, {
    "data-cy": "filter-nav-item"
  }, /*#__PURE__*/_react.default.createElement(FilterButton, (0, _extends2.default)({
    id: `id-${id}`,
    value: value,
    onClick: onClick,
    "aria-label": filterName,
    className: active ? 'active' : ''
  }, _tracking.default.create(_name, true, true)), filterName));
}
FilterNavItem.propTypes = {
  id: _propTypes.default.string,
  _name: _propTypes.default.string,
  filterName: _propTypes.default.string,
  onClick: _propTypes.default.func,
  active: _propTypes.default.bool,
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])
};

/**
 * FilterNav Component.
 *
 * @param {Object} props React props
 * @param {Array} props.categories Filter Categories
 * @param {Number} props.selected Pre Select Filter Item
 * @param {Function} props.handleAction Forwarded Onclick
 * @param {String} props.dataCy Forwarded Cypress Name
 * @param {Boolean} props.showScrollbar ScrollBar Condition
 * @returns {React.ReactElement} FilterNav Component
 * @public
 */

function FilterNav({
  children,
  dataCy,
  showScrollbar,
  handleAction,
  selected = 0,
  categories = []
}) {
  const [toggleState, setToggleState] = (0, _react.useState)(Number(selected));

  // TODO: CMS-30938 : Remove (categories). Should only render item as a React Node.
  const items = children || categories;
  const handleClick = (index, event) => {
    setToggleState(index);
    if (handleAction) {
      handleAction(event);
    }
  };
  if (!categories) return null;
  return /*#__PURE__*/_react.default.createElement(Container, {
    "data-cy": dataCy ? dataCy : 'filter-navigation',
    className: !showScrollbar && 'hidden-scrollbar'
  }, /*#__PURE__*/_react.default.createElement(GroupList, null, items?.map((child, index) => {
    return /*#__PURE__*/_react.default.isValidElement(child) ? (/*#__PURE__*/_react.default.cloneElement(child, {
      ...child.props,
      active: toggleState === index,
      onClick: e => handleClick(index, e)
    })) : /*#__PURE__*/_react.default.createElement(FilterNavItem, (0, _extends2.default)({
      active: toggleState === index,
      onClick: e => handleClick(index, e),
      value: index || child.value,
      key: index
    }, child));
  })));
}
var _default = exports.default = FilterNav;
FilterNav.propTypes = {
  children: _propTypes.default.arrayOf(_propTypes.default.node),
  categories: _propTypes.default.array,
  selected: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  handleAction: _propTypes.default.func,
  dataCy: _propTypes.default.string,
  showScrollbar: _propTypes.default.bool
};